import { Box } from "@mui/material";
import { ContainerCard, ContainerTitleStyled } from "./styles";
import { NormalText } from "../../shared/styles";
import { Key } from "@phosphor-icons/react";
import { KeyText } from "../../shared/key-text/key-text";

export const CredentialsContainer = ({ credentials }) => {
  return (
    <ContainerCard>
      <ContainerTitleStyled>
        <Key size={24} color="#1976D2" weight="fill" />
        <NormalText size={16} color={"#0F110C"} isBold>
          Credentials
        </NormalText>
      </ContainerTitleStyled>
      <Box
        display={"flex"}
        flexDirection={"column"}
        gap={"24px"}
        padding={"0 16px 16px 16px"}
      >
        <KeyText label={"API Key"} value={credentials.clientApiKey} />
        <KeyText
          label={"Session Token"}
          value={credentials.clientSessionToken}
        />
        <KeyText label={"ID"} value={credentials.id} />
      </Box>
    </ContainerCard>
  );
};
